import { render, staticRenderFns } from "./extra_benefits_table.vue?vue&type=template&id=5150ded2&scoped=true&"
import script from "./extra_benefits_table.vue?vue&type=script&lang=js&"
export * from "./extra_benefits_table.vue?vue&type=script&lang=js&"
import style0 from "./extra_benefits_table.vue?vue&type=style&index=0&id=5150ded2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150ded2",
  null
  
)

export default component.exports